import i18n from "../../../utils/i18n.js";
import RegistrationContactPage from "../../searchFlowVersionB/components/registrationContactPage/RegistrationContactPage.jsx";

const VafContactPage = (props) => (
  <RegistrationContactPage
    recommendationTitle={i18n.t("searchflow.vafofferrecommendation")}
    priceLabel={i18n.t("searchflow.vafofferpricelabel")}
    priceAmount={i18n.t("searchflow.vafofferpriceamount")}
    chipFields={["industry", "activity"]}
    callbacksource="vafrequest"
    createAspRequest={props.createAspRequest}
    onRequestError={props.onRequestError}
    handleNext={props.handleNext}
  />
);

export default VafContactPage;
